export const educatorFaqSX = {
    page: {
        mx: {
            xs: 2,
            sm: 10,
            md: 20,
            lg: 30,
        },
        mb: 30,
        minHeight: "100vh",
    },
    title: {
        my: 5,
    },
    ctaWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mt: 6,
    },
};
export const learnerFaqSx = {
    page: {
        mx: {
            xs: 2,
            sm: 10,
            md: 20,
            lg: 30,
        },
        mb: 30,
        minHeight: "100vh",
    },
    title: {
        my: 5,
    },
    ctaWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mt: 6,
    },
    ctaButton: {
        width: "50%",
        maxWidth: "200px",
    },
}
